<ng-container [ngSwitch]="websiteBlockData.WebsiteBlockType">
    <ng-container *ngSwitchCase="WebsiteBlockType.SignupForm">
        <lib-signup-form-design-block *ngLet="(websiteBlockData | method: WebsiteBlockDisplayItem.AsSignupForm) as signupBlock"
            [websiteBlockData]="signupBlock">
        </lib-signup-form-design-block>
    </ng-container>

    <ng-container *ngSwitchCase="WebsiteBlockType.ContactForm">
        <lib-contact-form-design-block *ngLet="(websiteBlockData | method: WebsiteBlockDisplayItem.AsContactForm) as contactBlock"
            [websiteBlockData]="contactBlock">
        </lib-contact-form-design-block>
    </ng-container>

    <ng-container *ngSwitchCase="WebsiteBlockType.LoginForm">
        <lib-login-form-design-block *ngLet="(websiteBlockData | method: WebsiteBlockDisplayItem.AsLoginForm) as loginBlock"
            [websiteBlockData]="loginBlock">
            @if (loginBlock.Header) {
                <ng-container header>
                    <span [innerHTML]="loginBlock.Header! | trustHtml"></span>
                </ng-container>
            }
        </lib-login-form-design-block>
    </ng-container>

    <ng-container *ngSwitchCase="WebsiteBlockType.Reviews">
        <lib-reviews-design-block *ngLet="(websiteBlockData | method: WebsiteBlockDisplayItem.AsReviews) as reviewsBlock"
            [websiteBlockData]="reviewsBlock">
        </lib-reviews-design-block>
    </ng-container>
</ng-container>
